export default {
	seconds: 'seconde(s)',
	minutes: 'minute(s)',
	hours: 'heure(s)',
	days: 'jour(s)',
	months: 'mois',
	years: 'année(s)',
};
